<template>
  <div class="layout">
    <div class="content-wrapper">
      <slot />
    </div>
  </div>
</template>
